import { Fragment } from "react";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { Button, Grid, MenuItem, Tooltip, Typography } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import VerifiedIcon from "@mui/icons-material/Verified";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useAlert, useAxios } from "../../hooks";

import pages from "../../constants/pages";
import { TextField } from "../../components";
import CustomField from "./CustomField";
import { setDependent } from "../../redux/slices/memberSlice";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import Color from "../../theme/color";

export default function Form({
  formikProps,
  sendInviteButton,
  setSendInviteButton,
}) {
  const axios = useAxios();
  const navigate = useNavigate();
  const { alert } = useAlert();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(location.search);

  const type = queryParams.get("type");

  const entityID = queryParams.get("entity_id");
  const visitorID = queryParams.get("visitor_id");
  const bookingID = queryParams.get("booking_id");
  const userTypeId = queryParams.get("user_type_id");

  const [userData, setUserData] = useState([]);
  const [badgeOptions, setBadgeOptions] = useState([]);
  const [dependentList, setDependentList] = useState([]);
  const [visitorVaild, setVisitorVaild] = useState([]);
  const [formData, setFormData] = useState({
    visitors: [
      {
        name: "",
        email_id: "",
        phone_number: "",
        badge: "",
        is_verified: false,
        edit: false,
        guestType: undefined,
      },
    ],
  });
  const [customFields, setCustomFields] = useState([]);

  const [dependentTrigger, setDependentTrigger] = useState(0);

  useEffect(() => {
    console.log("efewf");

    axios({
      url:
        "event/visitor/get-dependent-list?phone_number=" +
        visitorData.phoneNumber,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setDependentList(response.data || []);

        setDependentTrigger((prev) => prev + 1);
      }
    });
    if (userTypeId == 5) {
      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        if (response.status) {
          let data = Array(parseInt(response?.data[0]?.guests_count))
            .fill(true)
            .map((item, index) => {
              return {
                name:
                  index == 0
                    ? visitorData?.firstName + visitorData?.lastName
                    : "",
                email_id: index == 0 ? visitorData?.emailID : "",
                phone_number: index == 0 ? visitorData?.phoneNumber : "",
                badge_id: "",
                is_verified: visitorData?.isVerified || false,
                edit: index == 0 ? true : false,
                guestType: undefined,
                isContactInfoRequired: true,
              };
            });

          let array = Array(parseInt(response?.data[0]?.guests_count)).fill(
            true
          );
          array[0] = false;
          setVisitorVaild(array);

          setFormData({ visitors: data });
        }
      });
    } else if (userTypeId == 2) {
      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        if (response.status) {
          axios({
            url:
              "admin/custom-fields/get-appointment-fields?business_id=" +
              response.data[0]?.business_id,
            disableError: true,
            disableRedirect: true,
          }).then((response) => {
            if (response.status) {
              setCustomFields(response.data);
            }
          });

          setUserData(response.data);

          let dataLength = response.data[0]?.total_bookings;

          let data = Array(dataLength)
            .fill(true)
            .map((item, index) => {
              console.log(response.data[index], "response.data[index]");

              return {
                name:
                  response.data[index]?.visitor_info.first_name +
                    response.data[index]?.visitor_info.last_name || "",
                email_id: response.data[index]?.visitor_info.email_id || "",
                phone_number:
                  response.data[index]?.visitor_info.phone_number || "",
                badge_id: "",
                is_verified:
                  response.data[index]?.visitor_info?.is_verified || false,
                isContactInfoRequired:
                  response.data[index]?.journey_status
                    ?.is_contact_info_required || true,
                edit: response.data[index]?.visitor_info?.first_name
                  ? true
                  : false,
                guestType:
                  response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber
                    ? 1
                    : 0,
                ...(response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber && {
                  dependent: response.data[index]?.visitor_id,
                }),
              };
            });
          let array = Array(dataLength).fill(true);
          array[0] = false;
          console.log(data, "data");

          console.log(array, "array");

          setVisitorVaild(array);

          setFormData({ visitors: data });
        }
      });
    } else {
      axios({
        url: `event/booking/get-visitor-badges?visitor_id=${visitorID}&event_id=${entityID}`,
        method: "GET",
        disableRedirect: true,
      })
        .then((response) => {
          if (response.status) {
            setBadgeOptions(response.data);
          }
        })
        .catch((error) => {
          console.error("Error in fetching events list", error);
        });

      axios({
        url: "admin/custom-fields/get-event-fields?event_id=" + entityID,
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setCustomFields(response.data);
        }
      });

      let url = "admin/profile/get-visitor-booking-status";

      let method = "POST";

      let data = {
        visitor_id: visitorID,
        entity_id: entityID,
        user_type_id: userTypeId,
        booking_id: bookingID,
        face_data: getVisitorFaceData(visitorID),
      };

      axios({
        url: url,
        disableRedirect: true,
        method: method,
        data: data,
      }).then((response) => {
        console.log("cdscs");

        if (response.status) {
          setUserData(response.data);
          let dataLength = response.data[0]?.total_number_bookings;

          let data = Array(dataLength)
            .fill(true)
            .map((item, index) => {
              return {
                name:
                  response.data[index]?.visitor_info.first_name +
                    response.data[index]?.visitor_info.last_name || "",
                email_id: response.data[index]?.visitor_info.email_id || "",
                phone_number:
                  response.data[index]?.visitor_info.phone_number || "",
                badge_id: response.data[index]?.badge_id || "",
                is_verified:
                  response.data[index]?.visitor_info?.is_verified || false,

                edit: response.data[index]?.visitor_info?.first_name
                  ? true
                  : false,
                isContactInfoRequired:
                  response.data[index]?.journey_status
                    ?.is_contact_info_required || true,
                guestType:
                  response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber
                    ? 1
                    : 0,
                ...(response.data[index]?.visitor_info?.phone_number ===
                  visitorData?.phoneNumber && {
                  dependent: response.data[index]?.visitor_id,
                }),
              };
            });
          let array = Array(dataLength).fill(true);
          array[0] = false;
          setVisitorVaild(array);
          console.log(data, "data");

          setFormData({ visitors: data });
        }
      });
    }
  }, [axios, entityID]);

  function handleUpdateBadge(ID) {
    let badgeDetails = badgeOptions.filter((item) => item.badge_id === ID);

    axios({
      url: `/event/booking/update-visitor-badge`,
      method: "POST",
      data: {
        booking_id: userData[0].booking_id,
        badge_id: badgeDetails[0].badge_id,
        amount: badgeDetails[0].amount,
      },
    }).then((response) => {
      if (response.status) {
      }
    });
  }

  window.addEventListener("storage", () => {
    if (localStorage.getItem("windowClosed") === "true") {
      axios({
        url:
          "event/visitor/get-dependent-list?phone_number=" +
          visitorData.phoneNumber,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setDependentList(response.data || []);

          setDependentTrigger((prev) => prev + 1);
        }
      });
      localStorage.setItem("windowClosed", false);
    }
  });

  const generateFieldSchema = (field) => {
    let schema;

    switch (field.value_type) {
      case "string":
        schema = Yup.string();
        if (field.regex) {
          schema = schema.matches(
            new RegExp(field.regex),
            field.error_message || "Invalid format"
          );
        }
        break;

      case "boolean":
        schema = Yup.boolean();
        break;

      case "list":
        schema = Yup.array();
        break;

      default:
        schema = Yup.mixed(); // fallback
    }

    if (field.mandatory) {
      schema = schema.required(
        field.error_message || `${field.label} is required`
      );
    }

    return schema;
  };

  const dynamicVisitorSchemaShape = {};

  customFields.forEach((field) => {
    dynamicVisitorSchemaShape[field.name] = generateFieldSchema(field);
  });

  // Effect to update sendInviteButton state when dependencies change
  useEffect(() => {
    // if (formData.visitors.length > 0 && formikProps.values?.visitors) {\

    console.log("StaCSArt");

    const newSendInviteButtonState = {};

    const localStorageData = { ...localStorage };

    formData.visitors.forEach((visitor, index) => {
      const visitorDataKey = Object.keys(localStorageData).filter((item) => {
        return item.includes(
          formikProps.values?.visitors[index]?.dependent &&
            window.btoa(formikProps.values?.visitors[index]?.dependent)
        );
      });

      console.log(
        "end213132",
        Boolean(
          index !== 0 &&
            visitorVaild[index] &&
            !formikProps.values?.visitors[index]?.edit &&
            formikProps.values?.visitors[index]?.guestType == 1 &&
            !formikProps.values?.visitors[index].is_verified &&
            formikProps.values.visitors[index].dependent !== null
            ? !Boolean(
                dependentList[index - 1]?.is_verified &&
                  localStorage.getItem(visitorDataKey[0]) &&
                  formikProps.values?.visitors[index].dependent != 0
              )
            : false
        )
      );
      newSendInviteButtonState[index] = Boolean(
        index !== 0 &&
          visitorVaild[index] &&
          !formikProps.values?.visitors[index]?.edit &&
          formikProps.values?.visitors[index]?.guestType == 1 &&
          !formikProps.values?.visitors[index].is_verified &&
          formikProps.values.visitors[index].dependent !== null
          ? !Boolean(
              // dependentList[index - 1]?.is_verified &&
              localStorage.getItem(visitorDataKey[0]) &&
                formikProps.values?.visitors[index].dependent != 0
            )
          : false
      );
    });

    setSendInviteButton(newSendInviteButtonState);
    // }
  }, [
    formData.visitors.length,
    visitorVaild,
    formikProps.values?.visitors,
    setSendInviteButton,
    formikProps.values,
    dependentList.length,
    dependentTrigger,
  ]);

  return (
    <Fragment>
      {Array(formData.visitors.length)
        .fill(true)
        ?.map((item, index) => {
          function handleAddDependent() {
            formikProps.setFieldValue(
              `visitors[${index}].phone_number`,
              visitorData.phoneNumber
            );

            let name = formikProps.values?.visitors[index]?.name.split(" ");

            axios({
              url: "event/visitor/add-dependent",
              method: "POST",
              data: {
                phone_number: visitorData.phoneNumber,
                first_name: name[0] || "",
                last_name: name.slice(1).join(" ") || "",
                email_id: formikProps.values?.visitors[index]?.email_id,
              },
            })
              .then((response) => {
                if (response.status) {
                  dispatch(
                    alert({
                      type: "success",
                      message: response.message.displayMessage,
                    })
                  );
                  console.log("lllllllll");

                  axios({
                    url:
                      "event/visitor/get-dependent-list?phone_number=" +
                      visitorData.phoneNumber,
                    disableRedirect: true,
                  }).then((response) => {
                    if (response.status) {
                      dispatch(setDependent(response.data));
                      setDependentList(response.data || []);

                      setDependentTrigger((prev) => prev + 1);
                    }
                  });
                }
                formikProps.setFieldValue(
                  `visitors[${index}].dependent`,
                  response.data._id
                );
                localStorage.setItem("windowClosed", false);

                window.open(
                  `${pages.checkLiveliness?.route}?visitor_id=${
                    response.data._id
                  }&booking_id=${-1}&entity_id=${-1}&popup=true&doc_face=true&user_type_id=0`,
                  "",
                  "width=400,height=600"
                );

                setLoading(false);
              })
              .catch((error) => {
                setLoading(false);
              });
          }

          function handleSaveDependent() {
            localStorage.setItem("windowClosed", false);

            window.open(
              !userData[0]?.document_verification
                ? `${pages.Verification?.route}?visitor_id=${
                    formikProps.values.visitors[index].dependent
                  }&booking_id=${-1}&entity_id=${-1}&popup=true&doc_face=true&user_type_id=0`
                : `${pages.checkLiveliness?.route}?visitor_id=${
                    formikProps.values.visitors[index].dependent
                  }&booking_id=${-1}&entity_id=${-1}&popup=true&doc_face=true&user_type_id=0`,
              "",
              "width=400,height=600"
            );
          }

          const localStorageData = { ...localStorage };

          const visitorDataKey = Object.keys(localStorageData).filter(
            (item) => {
              return item.includes(
                formikProps.values?.visitors[index]?.dependent &&
                  window.btoa(formikProps.values?.visitors[index]?.dependent)
              );
            }
          );

          // Removed the setSendInviteButton call from here as it's now handled in useEffect

          return (
            <Grid item container key={index}>
              <Fragment>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    border: "1px solid black",
                    padding: "10px",
                    borderRadius: "8px",
                    margin: "10px 0px",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingTop: "0px",
                    }}
                  >
                    <Typography variant="body1" fontWeight={700}>
                      Person {index + 1}
                    </Typography>
                    {console.log(formikProps.values, "formikProps.values")}
                    {console.log(
                      formikProps.values?.visitors,
                      "formikProps.values?.visitors"
                    )}

                    {formikProps.values?.visitors[index]?.name && (
                      <Fragment>
                        {formikProps.values?.visitors[index]?.is_verified ||
                        (dependentList[index - 1]?.is_verified &&
                          localStorage.getItem(visitorDataKey[0]) &&
                          formikProps.values?.visitors[index].dependent !=
                            0) ? (
                          <Tooltip title="Verified">
                            <VerifiedIcon sx={{ color: "green" }} />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Not Verified User">
                            <NewReleasesIcon sx={{ color: "red" }} />
                          </Tooltip>
                        )}
                      </Fragment>
                    )}
                  </Grid>

                  {index !== 0 && (
                    <Grid item xs={12}>
                      <Typography variant="body1" fontWeight={700}>
                        Select Guest Type
                      </Typography>

                      <TextField
                        select
                        size="small"
                        name={`visitors[${index}].guestType`}
                        placeholder="Select Guest Type"
                        formikProps={formikProps}
                        onChange={(e) => {
                          formikProps.setFieldValue(
                            `visitors[${index}].guestType`,
                            e.target.value
                          );

                          formikProps.setFieldValue(
                            `visitors[${index}].dependent`,
                            null
                          );

                          formikProps.setFieldValue(
                            `visitors[${index}].is_dependent`,
                            true
                          );

                          formikProps.setFieldValue(
                            `visitors[${index}].name`,
                            ""
                          );
                          formikProps.setFieldValue(
                            `visitors[${index}].email_id`,
                            ""
                          );
                          formikProps.setFieldValue(
                            `visitors[${index}].phone_number`,
                            ""
                          );
                          formikProps.setFieldValue(
                            `visitors[${index}].is_verified`,
                            false
                          );
                        }}
                        disabled={formikProps.values?.visitors[index]?.edit}
                      >
                        {formikProps.values?.visitors[index]
                          ?.isContactInfoRequired && (
                          <MenuItem value={0}>New User</MenuItem>
                        )}
                        <MenuItem value={1}>Dependent</MenuItem>
                      </TextField>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    {visitorData?.dependentList &&
                      formikProps.values?.visitors[index]?.guestType === 1 &&
                      index !== 0 && (
                        <Grid
                          item
                          xs={12}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <TextField
                            select
                            size="small"
                            name={`visitors[${index}].dependent`}
                            placeholder="Select Dependent"
                            formikProps={formikProps}
                            onChange={(e) => {
                              if (e.target.value === 0) {
                                formikProps.setFieldValue(
                                  `visitors[${index}].dependent`,
                                  e.target.value
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].is_dependent`,
                                  true
                                );

                                formikProps.setFieldValue(
                                  `visitors[${index}].name`,
                                  ""
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].email_id`,
                                  ""
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].phone_number`,
                                  visitorData.phoneNumber
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].is_verified`,
                                  false
                                );
                              } else {
                                let dependent = dependentList.filter(
                                  (item, index) => item._id == e.target.value
                                );

                                formikProps.setFieldValue(
                                  `visitors[${index}].dependent`,
                                  e.target.value
                                );

                                formikProps.setFieldValue(
                                  `visitors[${index}].is_dependent`,
                                  true
                                );

                                formikProps.setFieldValue(
                                  `visitors[${index}].name`,
                                  dependent[0]?.first_name +
                                    " " +
                                    dependent[0]?.last_name
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].email_id`,
                                  dependent[0]?.email_id
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].phone_number`,
                                  dependent[0]?.phone_number
                                );
                                formikProps.setFieldValue(
                                  `visitors[${index}].is_verified`,
                                  dependent[0]?.is_verified
                                );
                              }
                            }}
                            disabled={formikProps.values?.visitors[index]?.edit}
                          >
                            {dependentList.length < 4 && (
                              <MenuItem value={0}>Add New Dependent</MenuItem>
                            )}
                            {dependentList.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item._id}>
                                  {item.first_name}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </Grid>
                      )}
                  </Grid>

                  {(index != 0
                    ? formikProps.values.visitors[index]?.guestType !==
                      undefined
                    : true) && (
                    <Fragment>
                      <Grid item xs={6}>
                        <Typography variant="body1">Enter Name</Typography>

                        <TextField
                          name={`visitors[${index}].name`}
                          placeholder="Enter Name"
                          size="small"
                          formikProps={formikProps}
                          disabled={formikProps.values?.visitors[index]?.edit}
                        />
                      </Grid>
                      {formikProps.values?.visitors[index]
                        ?.isContactInfoRequired && (
                        <Grid item xs={6}>
                          <Typography variant="body1">Enter Email</Typography>
                          <TextField
                            size="small"
                            name={`visitors[${index}].email_id`}
                            placeholder="Enter Email"
                            formikProps={formikProps}
                            disabled={formikProps.values?.visitors[index]?.edit}
                          />
                        </Grid>
                      )}

                      {formikProps.values?.visitors[index]
                        ?.isContactInfoRequired && (
                        <Grid item xs={userTypeId == 1 ? 6 : 12}>
                          <Typography variant="body1">
                            Enter Phone Number
                          </Typography>
                          <TextField
                            size="small"
                            name={`visitors[${index}].phone_number`}
                            placeholder="Enter Phone Number"
                            formikProps={formikProps}
                            disabled={formikProps.values?.visitors[index]?.edit}
                          />
                        </Grid>
                      )}

                      {userTypeId == 1 && (
                        <Grid item xs={6}>
                          <Typography variant="body1">Select Badge</Typography>
                          <TextField
                            select
                            size="small"
                            name={`visitors[${index}].badge_id`}
                            placeholder="Select Badge"
                            formikProps={formikProps}
                            onChange={(e) => {
                              formikProps.setFieldValue(
                                `visitors[${index}].badge_id`,
                                e.target.value
                              );

                              index === 0 && handleUpdateBadge(e.target.value);
                            }}
                          >
                            {badgeOptions.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.badge_id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </Grid>
                      )}

                      {index !== 0 && (
                        <CustomField
                          formikProps={formikProps}
                          customFields={customFields}
                          name={`customField[${index}].`}
                        />
                      )}

                      {/* Use sendInviteButton state to conditionally show the button */}
                      {sendInviteButton[index] && (
                        <Grid item xs={12}>
                          {formikProps.values.visitors[index].dependent !==
                          0 ? (
                            <Fragment>
                              {!Boolean(
                                localStorage.getItem(visitorDataKey[0])
                              ) && (
                                <Button
                                  fullWidth
                                  variant="contained"
                                  onClick={() => {
                                    handleSaveDependent(index);
                                  }}
                                  sx={{
                                    background:
                                      sessionStorage.getItem(
                                        "buttonBackground"
                                      ) || Color.digipass,
                                    color:
                                      sessionStorage.getItem("buttonColor") ||
                                      "#FFF",
                                  }}
                                >
                                  Save And Verify
                                </Button>
                              )}
                            </Fragment>
                          ) : (
                            <Button
                              fullWidth
                              variant="contained"
                              onClick={() => {
                                handleAddDependent(index);
                              }}
                              sx={{
                                background:
                                  sessionStorage.getItem("buttonBackground") ||
                                  Color.digipass,
                                color:
                                  sessionStorage.getItem("buttonColor") ||
                                  "#FFF",
                              }}
                            >
                              Add Dependent
                            </Button>
                          )}
                        </Grid>
                      )}
                    </Fragment>
                  )}
                </Grid>
              </Fragment>
            </Grid>
          );
        })}
      {console.log(
        Object.values(sendInviteButton).filter((item) => !!item),
        "oopaad"
      )}
      {!Boolean(
        Object.values(sendInviteButton).filter((item) => !!item).length
      ) && (
        <>
          {formikProps.values?.visitors[1]?.guestType === 1 ||
          formikProps.values?.visitors[1]?.guestType === 0 ||
          userTypeId == 5 ? (
            <Grid container xs={12}>
              <Button
                variant="contained"
                fullWidth
                disabled={!formikProps.isValid}
                onClick={formikProps.handleSubmit}
                sx={{
                  background:
                    sessionStorage.getItem("buttonBackground") ||
                    Color.digipass,
                  color: sessionStorage.getItem("buttonColor") || "#FFF",
                }}
              >
                Send Invite
              </Button>
            </Grid>
          ) : userTypeId == 2 ? (
            <Grid container xs={12}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  background:
                    sessionStorage.getItem("buttonBackground") ||
                    Color.digipass,
                  color: sessionStorage.getItem("buttonColor") || "#FFF",
                }}
                disabled={!formikProps.isValid}
                onClick={formikProps.handleSubmit}
              >
                Send Invite
              </Button>
            </Grid>
          ) : (
            <Button
              variant="contained"
              fullWidth
              disabled={!formikProps.isValid}
              sx={{
                background:
                  sessionStorage.getItem("buttonBackground") || Color.digipass,
                color: sessionStorage.getItem("buttonColor") || "#FFF",
              }}
              onClick={() => {
                navigate(
                  `${pages.EventSummary.route}?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`,
                  {
                    state: {
                      userData: userData,
                    },
                  }
                );
              }}
            >
              Save Badge
            </Button>
          )}
        </>
      )}
    </Fragment>
  );
}
